<template>
	<v-sheet class="asset" id="asset" style="height: calc(100vh - 88px)">
		<v-row>
			<v-col md="6" class="my-auto">
				<h1 class="custom-header-blue-text m-0">{{ pageTitle() }}</h1>
			</v-col>
			<v-col md="6" class="text-right">
				<v-btn
					:loading="pageLoading"
					class="white--text mr-2"
					depressed
					color="blue darken-4"
					tile
					:disabled="pageLoading || !formValid"
					v-on:click="updateOrCreate()"
				>
					Save
				</v-btn>
				<v-btn :disabled="pageLoading" depressed tile v-on:click="goBack()"> Cancel </v-btn>
			</v-col>
			<v-col md="12">
				<v-form
					ref="assetForm"
					v-model.trim="formValid"
					lazy-validation
					v-on:submit.stop.prevent="updateOrCreate"
				>
					<v-row>
						<v-col md="8">
							<perfect-scrollbar
								:options="{ suppressScrollX: true }"
								class="scroll custom-box-top-inner-shadow"
								style="max-height: calc(100vh - 160px); position: relative"
							>
								<v-row>
									<v-col md="12" class="py-0">
										<p class="middle-header-background mb-4 px-4">
											Core Information<br />
											<span>
												<v-icon small>mdi-progress-question</v-icon> Specify the primary description for your
												asset stock</span
											>
										</p>
									</v-col>
								</v-row>
								<v-row class="px-4">
									<v-col md="3" class="my-auto py-0">
										<label for="name" class="btx-label mt-2 required">Name</label>
									</v-col>
									<v-col md="9" class="py-0">
										<TextInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="name"
											:rules="[vrules.required(asset.name, 'Name')]"
											:class="{
												required: !asset.name,
											}"
											placeholder="Name"
											v-model="asset.name"
										></TextInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="model" class="btx-label mt-2">Barcode</label>
									</v-col>
									<v-col md="9" class="py-0">
										<TextInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="model"
											placeholder="Barcode"
											v-model="asset.pico_barcode"
										></TextInput>
									</v-col>
									<template v-if="false">
										<v-col md="3" class="my-auto py-0">
											<label for="model" class="btx-label mt-2 required">Model Number</label>
										</v-col>
										<v-col md="9" class="py-0">
											<TextInput
												hide-details
												:disabled="pageLoading"
												:loading="pageLoading"
												id="model"
												placeholder="Model Number"
												v-model="asset.model"
												:rules="[vrules.required(asset.model, 'Model')]"
												:class="{
													required: !asset.model,
												}"
											></TextInput>
										</v-col>
									</template>
									<v-col md="3" class="my-auto py-0">
										<label for="group" class="btx-label mt-2 required">Category</label>
									</v-col>
									<v-col md="9" class="py-0">
										<AutoCompleteInput
											hide-details
											:items="categoryList"
											:disabled="pageLoading"
											:loading="pageLoading"
											id="group"
											:rules="[vrules.required(asset.group, 'Category')]"
											:class="{
												required: !asset.group,
											}"
											v-on:change="getSubGroup($event)"
											placeholder="Category"
											v-model="asset.group"
											append-outer-icon="mdi-cog"
											v-on:click:append-outer="manageCategoryDialog = true"
										></AutoCompleteInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="color" class="btx-label mt-2">Color</label>
									</v-col>
									<v-col md="9" class="py-0">
										<TextInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="color"
											placeholder="Color"
											v-model="asset.color"
										></TextInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="size" class="btx-label mt-2">Size</label>
									</v-col>
									<v-col md="9" class="py-0">
										<TextInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="size"
											placeholder="Size"
											v-model="asset.size"
										></TextInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="purchased-on" class="btx-label mt-2 required">Purchased On</label>
									</v-col>
									<v-col md="9" class="py-0">
										<DatePicker
											hide-details
											clearable
											:disabled="pageLoading"
											:loading="pageLoading"
											id="purchased-on"
											placeholder="Purchased On"
											v-model="asset.purchased_on"
											:rules="[vrules.required(asset.purchased_on, 'Purchased On')]"
											:class="{
												required: !asset.purchased_on,
											}"
										></DatePicker>
									</v-col>

									<template v-if="subGroupList.length && false">
										<v-col md="3" class="my-auto py-0">
											<label for="sub-group" class="btx-label mt-2">Sub Group</label>
										</v-col>
										<v-col md="9" class="py-0">
											<AutoCompleteInput
												hide-details
												:items="subGroupList"
												:disabled="pageLoading"
												:loading="pageLoading"
												id="sub-group"
												placeholder="Sub Group"
												v-model="asset.sub_group"
											></AutoCompleteInput>
										</v-col>
									</template>
									<template v-if="false">
										<v-col md="3" class="my-auto py-0">
											<label for="id-number" class="btx-label mt-2"
												>Identification Number
												<TooltipQuestion>
													<template v-slot:text
														>Your unique identifier for this<br />Asset Stock. It can also be printed<br />and
														scanned as a barcode.</template
													>
												</TooltipQuestion>
											</label>
										</v-col>
										<v-col md="9" class="py-0">
											<TextInput
												hide-details
												:disabled="pageLoading"
												:loading="pageLoading"
												id="id-number"
												placeholder="Identification Number"
												v-model="asset.id_number"
											></TextInput>
										</v-col>
									</template>
									<v-col md="3" class="py-0">
										<label for="description" class="btx-label mt-2 required">Description</label>
									</v-col>
									<v-col md="9" class="py-0">
										<TextAreaInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="description"
											placeholder="Description"
											v-model="asset.description"
											:rules="[vrules.required(asset.description, 'Description')]"
											:class="{
												required: !asset.description,
											}"
										></TextAreaInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="contact" class="btx-label mt-2">Contact for Item</label>
									</v-col>
									<v-col md="9" class="py-0">
										<PhoneInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="contact"
											placeholder="Contact for Item"
											v-model="asset.contact"
										></PhoneInput>
									</v-col>
								</v-row>
								<v-row>
									<v-col md="12" class="py-0">
										<p class="middle-header-background my-4 mt-7 px-4">
											Extended Information<br />
											<span>
												<v-icon small>mdi-progress-question</v-icon> Specify the purchase, location and quantity
												details for your asset stock</span
											>
										</p>
									</v-col>
								</v-row>
								<v-row class="px-4">
									<v-col md="3" class="my-auto py-0">
										<label for="price-for-add-stock" class="btx-label mt-2 required"
											>Price For Add Stock
											<TooltipQuestion>
												<template v-slot:text>Default price for adding new stock</template>
											</TooltipQuestion>
										</label>
									</v-col>
									<v-col md="9" class="py-0">
										<PriceInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="price-for-add-stock"
											placeholder="Price For Add Stock"
											v-model="asset.price_add_stock"
											:rules="[vrules.required(asset.price_add_stock, 'Price For Add Stock')]"
											:class="{
												required: !asset.price_add_stock,
											}"
										></PriceInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="initial-stock-quantity" class="btx-label mt-2 required"
											>Stock Level
											<TooltipQuestion>
												<template v-slot:text
													>You can also add more stock<br />after creating the Asset Stock</template
												>
											</TooltipQuestion>
										</label>
									</v-col>
									<v-col md="9" class="py-0">
										<QuantityInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="initial-stock-quantity"
											placeholder="Stock Level"
											v-model="asset.stock_level"
											:rules="[vrules.required(asset.stock_level, 'Stock Level')]"
											:class="{
												required: !asset.stock_level,
											}"
										></QuantityInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="reorder-quantity" class="btx-label mt-2 required"
											>Reorder Level
											<TooltipQuestion>
												<template v-slot:text
													>Quantity to be added in Purchase<br />Order for this Asset Stock</template
												>
											</TooltipQuestion>
										</label>
									</v-col>
									<v-col md="9" class="py-0">
										<QuantityInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="reorder-quantity"
											placeholder="Reorder Quantity"
											v-model="asset.reorder_quantity"
											:rules="[vrules.required(asset.reorder_quantity, 'Reorder Quantity')]"
											:class="{
												required: !asset.reorder_quantity,
											}"
										></QuantityInput>
									</v-col>
									<v-col md="3" class="my-auto py-0">
										<label for="supplier" class="btx-label mt-2 required">Supplier</label>
									</v-col>
									<v-col md="9" class="py-0">
										<AutoCompleteInput
											hide-details
											:items="vendorList"
											:disabled="pageLoading"
											:loading="pageLoading"
											id="supplier	"
											placeholder="Supplier"
											v-model="asset.vendor"
											:rules="[vrules.required(asset.vendor, 'Supplier')]"
											:class="{
												required: !asset.vendor,
											}"
										></AutoCompleteInput>
									</v-col>
									<v-col md="3" class="py-0">
										<label for="attachment" class="btx-label mt-2">Attachment</label>
									</v-col>
									<v-col md="9" class="py-0">
										<v-file-input
											v-model="attachment"
											color="blue darken-4"
											small-chips
											placeholder="Click here to select files"
											multiple
											prepend-icon=""
											class="ctx-attachment-field mt-3 pt-0"
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											prepend-inner-icon="mdi-attachment mdi-rotate-315"
											outlined
											v-on:change="limitAttachment($event)"
										></v-file-input>
										<span class="font-small">Max 3 files allowed.</span>
									</v-col>
									<v-col md="3" class="py-0">
										<label for="remark" class="btx-label mt-2">Remark</label>
									</v-col>
									<v-col md="9" class="py-0">
										<TextAreaInput
											hide-details
											:disabled="pageLoading"
											:loading="pageLoading"
											id="remark"
											placeholder="Remark"
											v-model="asset.remark"
										></TextAreaInput>
									</v-col>
									<template v-if="false">
										<v-col md="3" class="my-auto py-0">
											<label for="vendor" class="btx-label mt-2 required">Incharge Officer</label>
										</v-col>
										<v-col md="9" class="py-0">
											<AutoCompleteInput
												hide-details
												:items="memberList"
												:disabled="pageLoading"
												:loading="pageLoading"
												id="vendor"
												placeholder="Incharge Officer"
												v-model="asset.member"
												:rules="[vrules.required(asset.member, 'Incharge Officer')]"
												:class="{
													required: !asset.member,
												}"
											></AutoCompleteInput>
										</v-col>
									</template>
									<template v-if="false">
										<v-col md="3" class="my-auto py-0">
											<label for="location" class="btx-label mt-2">Location</label>
										</v-col>
										<v-col md="9" class="py-0">
											<AutoCompleteInput
												hide-details
												:items="locationList"
												:disabled="pageLoading"
												:loading="pageLoading"
												id="location"
												placeholder="Location"
												v-model="asset.location"
												v-on:change="setDefaultLocation($event)"
												:rules="[vrules.required(asset.name, 'Name')]"
												:class="{
													required: !asset.name,
												}"
											></AutoCompleteInput>
										</v-col>
										<v-col md="3" class="my-auto py-0">
											<label for="low-stock-threshold" class="btx-label mt-2"
												>Low Stock Threshold
												<TooltipQuestion>
													<template v-slot:text
														>You will receive an email alert<br />when the total stock quantity<br />becomes less
														than this value</template
													>
												</TooltipQuestion>
											</label>
										</v-col>
										<v-col md="9" class="py-0">
											<QuantityInput
												hide-details
												:disabled="pageLoading"
												:loading="pageLoading"
												id="low-stock-threshold"
												placeholder="Low Stock Threshold"
												v-model="asset.low_stock"
												:rules="[vrules.required(asset.name, 'Name')]"
												:class="{
													required: !asset.name,
												}"
											></QuantityInput>
										</v-col>
									</template>
								</v-row>
								<template v-if="false">
									<v-row>
										<v-col md="12" class="py-0">
											<p class="middle-header-background my-4 mt-7 px-4">
												Location Specific Thresholds<br />
												<span>
													<v-icon small>mdi-progress-question</v-icon> Specify the low and excess location
													thresholds for your asset stock</span
												>
											</p>
										</v-col>
									</v-row>
									<v-row class="px-4">
										<v-col md="12" class="py-0">
											<table width="100%">
												<tr>
													<td width="33.33%">Location</td>
													<td width="33.33%" class="px-2">
														Low Location Threshold
														<TooltipQuestion>
															<template v-slot:text
																>For all locations without specified<br />thresholds, you will receive an<br />email
																alert when stock<br />quantity falls below this value</template
															>
														</TooltipQuestion>
													</td>
													<td width="33.33%">
														Excess Location Threshold
														<TooltipQuestion>
															<template v-slot:text
																>For all locations without specified<br />thresholds, you will receive an<br />email
																alert when stock<br />quantity is higher than this value</template
															>
														</TooltipQuestion>
													</td>
												</tr>
												<tr v-for="(row, index) in stockThresholds" :key="index">
													<td width="33.33%">
														<AutoCompleteInput
															v-if="index == 0"
															hide-details
															:items="locationList"
															:disabled="pageLoading"
															:loading="pageLoading"
															:id="`location-${index}`"
															placeholder="Default Location"
															v-model="row.location"
															readonly
														></AutoCompleteInput>
														<AutoCompleteInput
															v-else
															hide-details
															:items="locationList"
															:disabled="pageLoading"
															:loading="pageLoading"
															:id="`location-${index}`"
															placeholder="Location"
															v-model="row.location"
														></AutoCompleteInput>
													</td>
													<td width="33.33%" class="px-2">
														<QuantityInput
															hide-details
															:disabled="pageLoading"
															:loading="pageLoading"
															:id="`low-stock-threshold-${index}`"
															placeholder="Low Stock Threshold"
															v-model="row.low_stock"
														></QuantityInput>
													</td>
													<td :class="{ 'd-flex': index > 0 }">
														<QuantityInput
															hide-details
															:disabled="pageLoading"
															:loading="pageLoading"
															:id="`excess-stock-threshold-${index}`"
															placeholder="Excess Stock Threshold"
															v-model="row.excess_stock"
														></QuantityInput>
														<v-btn
															:disabled="pageLoading"
															v-if="index > 0"
															icon
															small
															class="mt-3 ml-2"
															color="red lighten-1"
															depressed
															tile
															v-on:click="removeLocation(index)"
														>
															<v-icon>mdi-delete</v-icon>
														</v-btn>
													</td>
												</tr>
												<tr>
													<td class="py-3" colspan="3">
														<v-btn
															:disabled="pageLoading"
															text
															color="blue darken-4"
															depressed
															tile
															v-on:click="addLocation()"
														>
															Add Location Specific Thresholds
														</v-btn>
													</td>
												</tr>
											</table>
										</v-col>
										<v-col md="12" class="min-height-40"> </v-col>
									</v-row>
								</template>
							</perfect-scrollbar>
						</v-col>
						<v-col md="4">
							<v-row>
								<v-col md="12" class="my-6 py-0 text-center">
									<ImageUpload can-change v-model="asset.image" :page-loading="pageLoading"></ImageUpload>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-form>
			</v-col>
		</v-row>
		<template v-if="manageCategoryDialog">
			<ManageCategory
				:dialog="manageCategoryDialog"
				:category="categoryList"
				v-on:close-dialog="manageCategoryDialog = false"
				v-on:success="getCategories"
			></ManageCategory>
		</template>
	</v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
import { UploadFiles } from "@/core/lib/upload.lib";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
import { CreateAssetStock, UpdateAssetStock, GetAssetStock } from "@/core/lib/asset-stock.lib";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TextInput from "@/view/components/TextInput";
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import TextAreaInput from "@/view/components/TextAreaInput";
import PhoneInput from "@/view/components/Phone";
import PriceInput from "@/view/components/PriceInput";
import QuantityInput from "@/view/components/QuantityInput";
import ImageUpload from "@/view/components/ImageUpload";
import TooltipQuestion from "@/view/components/TooltipQuestion";
import { filter, map } from "lodash";
import DatePicker from "@/view/components/DatePicker";
import ManageCategory from "@/view/components/Manage-Category.vue";

export default {
	name: "asset-create",
	title: "Create Asset",
	data() {
		return {
			uuid: null,
			barcode: null,
			formValid: true,
			pageLoading: false,
			manageCategoryDialog: false,
			attachment: [],
			categoryList: [],
			memberList: [],
			subGroupList: [],
			allSubGroupList: [],
			vendorList: [],
			locationList: [],
			stockThresholds: [
				{
					id: null,
					location: null,
					low_stock: null,
					excess_stock: null,
				},
			],
			asset: {
				name: null,
				model: null,
				group: null,
				color: null,
				size: null,
				sub_group: null,
				attachment: [],
				id_number: null,
				member: null,
				pico_barcode: null,
				description: null,
				remark: null,
				contact: null,
				price_add_stock: null,
				initial_stock: null,
				stock_level: null,
				reorder_quantity: 1,
				vendor: null,
				location: null,
				low_stock: null,
				image: null,
				purchased_on: null,
			},
		};
	},
	components: {
		TextInput,
		PhoneInput,
		PriceInput,
		QuantityInput,
		ImageUpload,
		TooltipQuestion,
		ManageCategory,
		TextAreaInput,
		AutoCompleteInput,
		DatePicker,
	},
	methods: {
		limitAttachment(output) {
			if (this.pageLoading) {
				return false;
			}

			this.attachment = output.slice(0, 3);

			if (this.attachment.length <= 0) {
				return false;
			}

			const request = new FormData();

			for (let i = 0; i < this.attachment.length; i++) {
				request.append(`files[${i}]`, this.attachment[i]);
			}

			this.pageLoading = true;

			UploadFiles(request)
				.then((response) => {
					this.asset.attachment = map(response, "path");
				})
				.catch((error) => {
					this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
		addLocation() {
			this.stockThresholds.push({
				id: null,
				location: null,
				low_stock: null,
				excess_stock: null,
			});
		},
		removeLocation(index) {
			this.stockThresholds.splice(index, 1);
		},
		async updateOrCreate() {
			const _this = this;

			const formErrors = _this.validateForm(_this.$refs.assetForm);
			if (formErrors.length) {
				_this.$store.commit(SET_ERROR, _this.errors.concat(formErrors));
				return false;
			}

			if (!_this.$refs.assetForm.validate()) {
				return false;
			}

			const formData = {
				name: this.asset.name,
				model: this.asset.model,
				group: this.asset.group,
				color: this.asset.color,
				size: this.asset.size,
				sub_group: this.asset.sub_group,
				id_number: this.asset.id_number,
				description: this.asset.description,
				attachment: this.asset.attachment,
				contact: this.asset.contact,
				remark: this.asset.remark,
				price_add_stock: this.asset.price_add_stock,
				initial_stock: this.asset.initial_stock,
				stock_level: this.asset.stock_level,
				reorder_quantity: this.asset.reorder_quantity,
				supplier: this.asset.vendor,
				location: this.asset.location,
				low_stock: this.asset.low_stock,
				image: this.asset.image,
				stock_thresholds: this.stockThresholds,
				pico_barcode: this.asset.pico_barcode,
				member: this.asset.member,
				purchased_on: this.asset.purchased_on,
			};

			try {
				_this.pageLoading = true;

				if (_this.uuid) {
					const { uuid } = await UpdateAssetStock(_this.uuid, formData);

					_this.$router.replace({
						name: "asset-stock-detail",
						params: { uuid },
						query: { t: new Date().getTime() },
					});

					_this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Asset Stock has been updated." },
					]);
				} else {
					const { uuid } = await CreateAssetStock(formData);

					_this.$router.replace({
						name: "asset-stock-detail",
						params: { uuid },
						query: { t: new Date().getTime() },
					});

					_this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Asset Stock has been created." },
					]);
				}
			} catch (error) {
				_this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
			} finally {
				_this.pageLoading = false;
			}
		},
		setDefaultLocation(param) {
			this.stockThresholds[0].location = param;
		},
		getSubGroup(param) {
			this.subGroupList = filter(this.allSubGroupList, { group: param });
		},
		getAssetStock(uuid) {
			GetAssetStock(uuid)
				.then((data) => {
					this.barcode = data.barcode;
					this.asset.name = data.name;
					this.asset.model = data.model;
					this.asset.group = data.group;
					this.asset.sub_group = data.sub_group;
					this.asset.color = data.color;
					this.asset.size = data.size;
					this.asset.remark = data.remark;
					this.asset.id_number = data.id_number;
					this.asset.description = data.description;
					this.asset.contact = data.contact;
					this.asset.price_add_stock = data.price_add_stock;
					this.asset.initial_stock = data.initial_stock;
					this.asset.stock_level = data.stock_level;
					this.asset.reorder_quantity = data.reorder_quantity;
					this.asset.vendor = data.supplier;
					this.asset.location = data.location;
					this.asset.low_stock = data.low_stock;
					this.asset.pico_barcode = data.pico_barcode;
					this.asset.purchased_on = data.purchased_on;
					this.asset.member = data.member;
					this.asset.image = data.image;

					if (data.stock_thresholds && data.stock_thresholds.length) {
						this.stockThresholds = data.stock_thresholds.map((row) => {
							return {
								id: row.id,
								location: row.location,
								low_stock: row.low_location,
								excess_stock: row.excess_location,
							};
						});
					}

					this.$nextTick(() => {
						if (this.asset.location) {
							this.setDefaultLocation(this.asset.location);
						}

						if (this.asset.group) {
							this.getSubGroup(this.asset.group);
						}
					});

					this.$store.dispatch(SET_BREADCRUMB, [
						{ text: "Asset Stock", disabled: true },
						{ text: "Update", disabled: true },
						{ text: this.barcode, disabled: true },
					]);
				})
				.catch((error) => {
					this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
		pageTitle() {
			if (this.uuid) {
				return this.asset.name;
			}
			return "Create new Asset Stock";
		},
		getCategories(data) {
			this.categoryList = data;
		},
	},
	computed: {
		...mapGetters(["errors", "localDB"]),
	},
	mounted() {
		this.categoryList = this.localDB("groups", []);
		this.allSubGroupList = this.localDB("sub_groups", []);
		this.vendorList = this.localDB("suppliers", []);
		this.locationList = this.localDB("locations", []);
		this.memberList = this.localDB("members", []);

		this.$store.dispatch(SET_BREADCRUMB, [
			{ text: "Asset Stock", disabled: true },
			{ text: "Create", disabled: true },
		]);
		console.log(this.$route);
		const { name, params, query } = this.$route;

		if (query && query.supplier) {
			this.asset.vendor = query.supplier;
		}

		if (query && query.group) {
			this.asset.group = query.group;
		}

		if (name === "asset-stock-update") {
			this.uuid = params.uuid;
			if (!this.uuid) {
				this.goBack();
			}
			this.pageLoading = true;
			this.getAssetStock(this.uuid);
		}
		if (query && query.duplicate) {
			this.getAssetStock(query.duplicate);
		}
	},
	beforeDestroy() {
		this.$store.dispatch(SET_BREADCRUMB, []);
	},
};
</script>
